import { combine, createEvent, createStore, type Effect } from 'effector';
import { pending } from 'patronum';
import {
  ChannelInstance,
  MessageInstance,
} from '@features/socket-chats-reworked/types/common';
import type { ContactInstance } from '../../types/contact';
import { $channels } from '../channels/channels.model';
import { fxGetChannelContacts } from '../contacts/contacts.model';
import { ADD_CONTACTS_IN_GROUP, fx } from '../socket/socket.model';
import type { AddContactsInGroupPayload } from './types';

export const fxAddContactsInGroup: Effect<AddContactsInGroupPayload, void, Error> =
  fx[ADD_CONTACTS_IN_GROUP];

export const $currentChatId = createStore<ChannelInstance['id'] | null>(null);
// export const $chatData = createStore<ChannelInstance | null>(null);
export const $chatData = combine($currentChatId, $channels, (currentChatId, channels) =>
  currentChatId ? channels[currentChatId] : null
);
export const $isReadonly = createStore<boolean>(false);
export const $isChatLoading = pending({
  effects: [fxGetChannelContacts],
});
export const $isSelectMode = createStore<boolean>(false);
export const $selectedMessages = createStore<MessageInstance['id'][]>([]);
export const $isDrawerVisible = createStore<boolean>(false);
export const $isOpenAddContactsModal = createStore<boolean>(false);

export const openChat = createEvent<ChannelInstance['id']>();
export const chatOpened = createEvent<ChannelInstance['id']>();
export const toggleSelectMode = createEvent();
export const selectMessage = createEvent<MessageInstance['id']>();
export const deselectMessage = createEvent<MessageInstance['id']>();
export const clearSelectedMessages = createEvent();
export const setDrawerVisibility = createEvent<boolean>();
export const changeVisibilityAddContactsModal = createEvent<boolean>();
export const addContactsInGroup = createEvent<ContactInstance[]>();

export const $forwardedMessages = createStore<MessageInstance[]>([]);
export const clearForwardedMessages = createEvent();
